/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import ReactSelect from "react-select";

/** Common Components */
import Label from "../../components/ui/label/Label";
import Buttons from "../../components/ui/button/Buttons";
import Input from "../../components/ui/inputs/input/Input";
import DropdownSelect from "../../components/ui/dropdown/DropdownSelect";

/** Common Services & Data Files */
import { AppIcons } from "../../data/appIcons";
import ToastService from "../../services/toastService/ToastService";

/** RTK Query */
import { useAddTaskMutation } from "../../app/services/taskAPI";
import { useLazyGetAllTaskTypeListQuery } from "../../app/services/taskTypeAPI";
import { useLazyGetAllPriorityListQuery } from "../../app/services/priorityAPI";
import { useLazyGetProjectModuleByProjectIdQuery } from "../../app/services/projectModuleAPI";
import { useGetProjectVersionListMutation } from "../../app/services/projectVersionAPI";
import { useGetProjectComponentListMutation } from "../../app/services/projectComponentAPI";
import { useGetAllProjectTeamListMutation } from "../../app/services/projectTeamManagementAPI";
import { useLazyGetAssignProjectListByUserIdQuery } from "../../app/services/projectManagementAPI";

/** CSS Files */
import "../task/edittask/EditTask.scss";
import SwalAlert from "../../services/swalService/SwalService";
import DatePickerComponent from "../../components/finalForms/ui/inputs/datePicker/DatePicker";
import { encryptUrlData } from "../../services/CryptoService";
import CKEditorComponent from "../../components/finalForms/ui/inputs/ckEditor/CKEditor";
import { editorConfig } from "../../components/finalForms/ui/inputs/ckEditor/CkEditorConfig";
import FileUpload from "../../components/finalForms/ui/inputs/fileUpload/FileUpload";
import { FileFormats } from "../../components/finalForms/libs/data/fileFormatTypes";
import { NumberValueType } from "../../components/finalForms/libs/data/formControlTypes";
import { validateFile } from "../../utils/Validation/ValidateField";
import AvatarSelect from "../../components/tasks/elementalUI/avatarselect/AvatarSelect";


const CreateTask = ({ projectId, typeId, PlanningId, synergyId ,onClose }) => {

  const { user } = useSelector((state) => state.auth);
  const UserID = user.userId;
  const UserName = user.userName;

  const { error } = SwalAlert();

  const [projectList, setProjectList] = useState(null);
  const [taskType, setTaskType] = useState([]);
  const [taskPriority, setTaskPriority] = useState([]);
  const [projectComponent, setProjectComponent] = useState([]);
  const [projectModule, setProjectModule] = useState([]);
  const [projectVersion, setProjectVersion] = useState([]);
  const [assignUserList, setAssignUserList] = useState([]);
  const [reportedUserList, setReportedUserList] = useState([]);

  const [selprojectId, setSelprojectId] = useState(projectId);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [taskTypeId, setTaskTypeId] = useState(null);
  const [priorityId, setPriorityId] = useState(null);
  const [estimateHours, setEstimateHours] = useState(null);
  const [deadLine, setDeadLine] = useState(new Date());
  const [assignedTo, setAssignedTo] = useState({
    value: UserID,
    label: UserName,
  });
  const [reportTo, setReportTo] = useState({
    value: UserID,
    label: UserName,
  });
  const [componentId, setComponentId] = useState(null);
  const [moduleId, setModuleId] = useState(null);
  const [versionId, setVersionId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [isSaveAndClose, setIsSaveAndClose] = useState(false);

  const [attachment, setAttachment] = useState([]);


  const [getAllPriorityList, {
    isFetching: isPriorityFetching,
    isSuccess: isPrioritySuccess,
    data: isPriorityData,
  },] = useLazyGetAllPriorityListQuery();


  const [getAllProjectComponentList, {
    isLoading: isProjectComponentListLoading,
    isSuccess: isProjectComponentListSuccess,
    data: isLProjectComponentListeData,
  },] = useGetProjectComponentListMutation();

  const [getProjectModuleByProjectId, {
    isFetching: isgetProjectModuleByProjectIdfetching,
    isSuccess: isgetProjectModuleByProjectIdsuccess,
    data: isgetProjectModuleByProjectIdData,
  },] = useLazyGetProjectModuleByProjectIdQuery();

  const [getAllProjectVersionList, {
    isLoading: isProjectVersionListLoading,
    isSuccess: isProjectVersionListSuccess,
    data: isLProjectVersionListeData,
  },] = useGetProjectVersionListMutation();

  const [getAssignedUserList, {
    isFetching: isAssignedUserNameFetching,
    isSuccess: isAssignedUserName,
    data: assignedUserNameData,
  },] = useGetAllProjectTeamListMutation();

  const [getAllTaskTypeList, {
    isFetching: isTaskTypeFetching,
    isSuccess: isTaskTypeFetched,
    data: TaskTypeData,
  },] = useLazyGetAllTaskTypeListQuery();

  const [addTask, {
    isSuccess: isTaskAdded,
    isLoading: isTaskAdding,
    data: addTaskData
  },] = useAddTaskMutation();

  const [getAssignProjectListByUserId, {
    isSuccess: isListSuccess,
    data: ProjectList
  },] = useLazyGetAssignProjectListByUserIdQuery();

  const filterPassedDate = (date) => {
    if (!deadLine) return true;
    const currentDate = new Date();
    const selectedDate = new Date(date);
    return selectedDate.getTime() >= currentDate.getTime();
  };

  useEffect(() => {
    if (UserID) {
      getAssignProjectListByUserId(UserID);
    }
  }, [UserID, getAssignProjectListByUserId]);

  useEffect(() => {
    if (isListSuccess && ProjectList) {
      const projectsData = ProjectList.map((item) => ({
        value: item.projectId,
        label: item.projectName,
      }));
      setProjectList(projectsData);
      if (projectId) {
        setSelprojectId(
          projectsData.find((option) => option.value === projectId) || null
        );
      }
    }
  }, [isListSuccess, ProjectList]);

  useEffect(() => {
    getAllTaskTypeList();
    // getProjectModuleByProjectId(projectId === 'undefine' ? projectId : '0' || selprojectId);
    getProjectModuleByProjectId(projectId ? projectId : 0 || selprojectId);
    getProjectComponentList();
    getAllPriorityList();
    getProjectversiontList();
    getUserListByProjectId();
  }, [projectId]);

  const handalprojectchange = (option) => {
    setSelprojectId(option)
    setComponentId(null);
    setVersionId(null);
    setModuleId(null);
    setReportTo(null);
    setAssignedTo(null);
    if (option) {
      const request = {
        pagination: {
          pageNumber: 1,
          pageSize: 100,
        },
        filters: {
          searchText: "",
        },
        projectId: option.value
      };
      getProjectModuleByProjectId(request.projectId)
      getAssignedUserList(request);
      getAllProjectComponentList(request);
      getAllProjectVersionList(request);
    }
  }

  const getUserListByProjectId = () => {
    const request = {
      pagination: {
        pageNumber: 1,
        pageSize: 40,
      },
      projectId: projectId,
    };
    getAssignedUserList(request);
  };
  const getProjectComponentList = () => {
    const request = {
      pagination: {
        pageNumber: 1,
        pageSize: 40,
      },
      projectId: projectId,
    };
    getAllProjectComponentList(request);
  };

  const getProjectversiontList = () => {
    const request = {
      pagination: {
        pageNumber: 1,
        pageSize: 40,
      },
      projectId: projectId,
    };
    getAllProjectVersionList(request);
  };

  useEffect(() => {
    if (!isTaskTypeFetching && isTaskTypeFetched && TaskTypeData) {
      const taskTypeListData = TaskTypeData.map((item) => ({
        value: item.taskTypeId,
        label: item.taskTypeName,
        imagePath:
          item.taskTypeId === 1
            ? AppIcons.Task
            : item.taskTypeId === 2
              ? AppIcons.Bug
              : null,
      }));
      setTaskType(taskTypeListData);
      if (typeId) {
        setTaskTypeId(
          taskTypeListData.find((option) => option.value === typeId) || null
        );
      }
    }
  }, [isTaskTypeFetching, isTaskTypeFetched, TaskTypeData]);

  useEffect(() => {
    if (!isPriorityFetching && isPrioritySuccess && isPriorityData) {
      const priorityList = isPriorityData.map((item) => ({
        value: item.priorityId,
        label: item.priorityName,
      }));
      setTaskPriority(priorityList);
      setPriorityId(priorityList[0]);

    }
  }, [isPriorityFetching, isPrioritySuccess, isPriorityData]);

  useEffect(() => {
    if (
      !isProjectComponentListLoading &&
      isProjectComponentListSuccess &&
      isLProjectComponentListeData
    ) {
      const projectComponentListData =
        isLProjectComponentListeData.dataSource.map((item) => ({
          value: item.projectComponentId,
          label: item.projectComponent,
        }));
      setProjectComponent(projectComponentListData);
    }
  }, [
    isProjectComponentListLoading,
    isProjectComponentListSuccess,
    isLProjectComponentListeData,
  ]);

  useEffect(() => {
    if (
      !isgetProjectModuleByProjectIdfetching &&
      isgetProjectModuleByProjectIdsuccess &&
      isgetProjectModuleByProjectIdData
    ) {
      const projectModuleListData = isgetProjectModuleByProjectIdData.map(
        (item) => ({
          value: item.projectModuleId,
          label: item.projectModule,
        })
      );
      setProjectModule(projectModuleListData);
    }
  }, [
    isgetProjectModuleByProjectIdfetching,
    isgetProjectModuleByProjectIdsuccess,
    isgetProjectModuleByProjectIdData,
  ]);

  useEffect(() => {
    if (
      !isProjectVersionListLoading &&
      isProjectVersionListSuccess &&
      isLProjectVersionListeData
    ) {
      const projectVersionListData = isLProjectVersionListeData.dataSource.map(
        (item) => ({
          value: item.projectVersionId,
          label: item.projectVersion,
          isRelease: item.isRelease,
        })
      );
      const filterdata = projectVersionListData.filter((f) => f.isRelease);
      setProjectVersion(filterdata);
    }
  }, [
    isProjectVersionListLoading,
    isProjectVersionListSuccess,
    isLProjectVersionListeData,
  ]);

  useEffect(() => {
    if (!isAssignedUserNameFetching && isAssignedUserName && assignedUserNameData) {
      const userNameList = assignedUserNameData.dataSource.map((item) => ({
        value: item.userId,
        label: item.userName,
      }));
      setAssignUserList(userNameList);
      setReportedUserList(userNameList);
      if (UserID) {
        setReportTo(
          userNameList.find((option) => option.value === UserID) || null
        );
        setAssignedTo(
          userNameList.find((option) => option.value === UserID) || null
        );

      }
    }
  }, [isAssignedUserNameFetching, isAssignedUserName, assignedUserNameData]);

  useEffect(() => {

    if (isTaskAdded && addTaskData) {
      if (addTaskData.keyValue === 0) {
        error(addTaskData.errorMessage);
      } else if (addTaskData.errorMessage.includes("exists")) {
        ToastService.warning(addTaskData.errorMessage);
      } else {
        ToastService.success(addTaskData.errorMessage);
        if (isSaveAndClose) {
          onClose();
        }
        if (isEdit) {
          const dataURL = {};
          dataURL.taskId = addTaskData.keyValue;
          dataURL.projectId = extractDropdownValue(selprojectId) || projectId;
          window.open(`/project/EditTask/${encryptUrlData(dataURL)}}`, "_blank");
        }
        resetForm();
      }
    }
  }, [isTaskAdded, addTaskData]);

  const handleFileChange = (e) => {
    if (e.target.files?.length > 0) {
      const uploadfile = e.target.files[0]; // Select the first file

      const readFileAsDataURL = (file, callback) => {
        const reader = new FileReader();

        reader.onload = () => {
          callback(reader.result); // Pass the Base64 data to the callback
        };

        reader.onerror = (error) => {
          console.error('Error reading file:', error);
        };

        reader.readAsDataURL(file);
      };

      // Call readFileAsDataURL and provide a callback to handle the result
      readFileAsDataURL(uploadfile, (base64Data) => {

        const fileObj = {
          file: uploadfile,
          fileName: uploadfile.name,
          base64Data: base64Data,
        }

        const validationResult = validateFile(uploadfile, [FileFormats.ALL], 0, 8);

        if (!validationResult.isValid) {

          error(validationResult.errorMessage, "Validation Failed !");
        } else {

          setAttachment([fileObj]);
        }

      });
    }
  };

  const handleAttachmentClear = (index) => {
    if (index !== null) {
      setAttachment(null);
    }
  }

  /** Set Dropdown Value */
  const extractDropdownValue = field => field && typeof field === 'object' ? field.value : field;

  const handleSave = () => {
    saveTask()
    setIsEdit(false)
    setIsSaveAndClose(false)
  };
  const handleSaveAndClose = () => {
    saveTask()
    setIsEdit(false)
    setIsSaveAndClose(true)
  };

  const handleSaveAndEdit = () => {
    saveTask()
    setIsEdit(true)
    setIsSaveAndClose(false)
    // onClose();
    // window.location.reload();
  };
  const handleCKEditorChange = (newData) => {
    setDescription(newData);
  };


  const handleEstTimeChange = (e) => {
    const numericValue = e.target.value;
    setEstimateHours(numericValue);
  }

  const getLoggedInUser = () => {
    return reportedUserList.find((user) => user.value === UserID) || null;
  };

  const handalChangeAssignTo = (newSelectedOptions) => {
    setAssignedTo(newSelectedOptions[0]);
  }
  const handalChangeReportTo = (newSelectedOptions) => {
    setReportTo(newSelectedOptions[0]);
  }

  const saveTask = () => {
    const requestData = {
      taskTypeId: extractDropdownValue(taskTypeId),
      priorityId: extractDropdownValue(priorityId),
      componentId: extractDropdownValue(componentId),
      moduleId: extractDropdownValue(moduleId),
      versionId: extractDropdownValue(versionId),
      title: title,
      projectId: extractDropdownValue(selprojectId?.value) || projectId,
      estimateHours: estimateHours || 0,
      assignedTo: assignedTo ? extractDropdownValue(assignedTo) : UserID,
      reportTo: reportTo ? extractDropdownValue(reportTo) : UserID,
      deadLine: deadLine,
      description: description,
      attachmentPath: attachment?.[0]?.fileName,
      attachmentType: attachment?.[0]?.file.type,
      base64File: attachment?.[0]?.base64Data,
      storagePath: '',
      planningId: PlanningId || null,
      synergyID : synergyId || null
    };
    if (!requestData.projectId || !taskTypeId || !title) {
      error("please fill all the required fields.", "Validation Failed!");
    } else {
      addTask(requestData);
    };
  }
  const resetForm = () => {
    setTitle("");
    setDescription("");
    setEstimateHours(null);
    setReportTo(getLoggedInUser());
    setComponentId(null);
    setModuleId(null);
    setVersionId(null);
    setAttachment(null);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderColor: "#ccc",
      "&:hover": {
        borderColor: "#888",
      },
      boxShadow: "none",
    }),
    option: (provided, state) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      padding: 10,
      backgroundColor: state.isSelected ? "#f0f0f0" : "#fff",
      "&:hover": {
        backgroundColor: "#eee",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
    }),
  };

  return (
    <>
      {/* <RenderTabs tabs={tabs} /> */}
      {/* <BasicInformation /> */}
      <div className="task-container">
        <div className="row">
          <div className="col-6">
            <Label labelName="Project Name" isRequired={true} />
            <DropdownSelect
              optionsValue={projectList}
              value={selprojectId}
              handleDropdownChange={handalprojectchange}
              placeholder="Select Project"
            />
          </div>

          <div className="col-6 pl-0">
            <div className="task-header">
              <Label labelName="Task Type" isRequired={true} />
              <ReactSelect
                styles={customStyles}
                classNamePrefix="task-type"
                options={taskType}
                placeholder="Task Type"
                value={taskTypeId}
                onChange={(selectedOption) => setTaskTypeId(selectedOption)}
                formatOptionLabel={({ label, imagePath }) => (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {imagePath && <img src={imagePath} alt={""} />}
                    {label}
                  </div>
                )}
              />
            </div>
          </div>
          <div className="col-12 mt-1">
            <div className="task-header">
              <Label labelName="Task Title" isRequired={true} />
              <Input
                maxLength={200}
                type="text"
                className="task-title input-field"
                placeholder="Task Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="task-editor mt-1">
          <Label labelName="Description" />
          <CKEditorComponent
            data={description}
            isdisable={false}
            onCKEditorChange={handleCKEditorChange}
            config={{
              ...editorConfig,
              placeholder: 'Please Enter Task Description'
            }}
            inputInfoConfig={{
              isInfoIcon: true,
              iconName: 'info-circle',
              message: 'This is a rich text editor.'
            }}

          />
        </div>
      </div>

      <div className="task-details ">
        <div className="row">
          <div className="col-6 mb-1 assign-user">
            <Label labelName="Assign User" />
            <AvatarSelect
              initState={{
                value: assignedTo?.value,
                label: assignedTo?.label
              }}
              onSelectionChange={handalChangeAssignTo}
              options={assignUserList}
              selectMode="single"
            />
          </div>
          <div className="col-6 assign-user">
            <Label labelName="Reported User" />
            <AvatarSelect
              initState={{
                value: reportTo?.value,
                label: reportTo?.label
              }}
              onSelectionChange={handalChangeReportTo}
              options={reportedUserList}
              selectMode="single"
            />
          </div>

          <div className="col-4 mb-1">
            <Label labelName="Priority" />
            <DropdownSelect
              optionsValue={taskPriority}
              value={priorityId}
              handleDropdownChange={setPriorityId}
              placeholder="Select Priority"
            />
          </div>
          <div className="col-2 time-field">
            <Label labelName="Est. Time" />
            <Input
              type="number"
              className="input-time-field"
              placeholder="Est. time"
              value={estimateHours || ''}
              valueType={NumberValueType.DECIMAL}
              onChange={(e) => {
                const value = parseFloat(e.target.value);
                if (isNaN(value)) {
                  handleEstTimeChange(e);
                }
                else if (value >= 0 && value <= 90) {
                  handleEstTimeChange(e);
                }
              }
              }
              min={0}
              max={90}
              step={0.1}
            />
          </div>
          <div className="col-6 deadline">
            <Label labelName="DeadLine" />
            {/* <ReactDatePicker
              selected={deadLine}
              onChange={(date) => setDeadLine(date)}
              placeholderText="Select Deadline"
            /> */}
            <DatePickerComponent
              isDisable={false}
              selected={deadLine}
              onChange={(date) => setDeadLine(date)}
              placeholder={"Select Deadline"}
              datePickerConfig={
                {
                  filteredDate: filterPassedDate,
                  timeInputLabel: "DeadLine:",
                  timeFormat: "p",
                  timeIntervals: 15,
                  format: "dd/MM/yyyy"
                }
              }
            />
          </div>

          <div className="mb-2 col-4">
            <Label labelName="Component" />
            <DropdownSelect
              optionsValue={projectComponent}
              value={componentId}
              handleDropdownChange={setComponentId}
              placeholder="Select Component"
            />
          </div>
          <div className="mb-2 col-4">
            <Label labelName="Module" />
            <DropdownSelect
              optionsValue={projectModule}
              value={moduleId}
              handleDropdownChange={setModuleId}
              placeholder="Select Module"
            />
          </div>
          <div className="mb-2 col-4">
            <Label labelName="Version" />
            <DropdownSelect
              optionsValue={projectVersion}
              value={versionId}
              handleDropdownChange={setVersionId}
              placeholder="Select Version"
            />
          </div>


          <div className="mb-2 col-8">
            <Label labelName="Attachment" />
            <FileUpload
              name=""
              onChange={handleFileChange}
              onClear={(index) => handleAttachmentClear(index)}
              placeholder="Upload Task attachment"
              isMultipleFileAllowed={false}
              acceptedFileFormats={[FileFormats.ALL]}
              selectedFileValues={attachment}
              fieldSetting={{
                placeholder: "Upload File",
                allowMultipleFiles: false,
                // acceptedFileFormats: [FileFormats.ALL],
                minFileSizeInMB: 0, // Minimum File size in MB
                maxFileSizeInMB: 8, // Maximum File size in MB
              }}
            />
          </div>



        </div>
      </div>

      <div className="">
        <div className="d-flex justify-content-between task-button mt-2">
          <div className="d-flex">
            <Buttons
              buttonTypeClassName="theme-btn"
              buttonText="Save and Close"
              onClick={handleSaveAndClose}
              isLoading={isTaskAdding}
            />
            <Buttons
              buttonTypeClassName="theme-btn ml-2"
              buttonText="Save and Edit"
              onClick={handleSaveAndEdit}
              isLoading={isTaskAdding}
            />
          </div>

          <Buttons
            buttonTypeClassName="theme-btn"
            buttonText="Save and Add New"
            onClick={handleSave}
            isLoading={isTaskAdding}
          />

        </div>
      </div>
    </>
  );
};

export default CreateTask;